<div class="VizseekTitle">
    <span>{{'common.vizseek_Search_results'| cxTranslate}}</span>
    <button class="dialog-close-btn" aria-label="close dialog" mat-dialog-close>
        <img src="/icons/close-kb.svg" alt="" class="close" width="20" />
    </button>
</div>
<mat-dialog-content class="vizseekContent">
    <div class="mt-3">

        <span>{{'common.vizseek_search_Invalid_text1'|cxTranslate}}</span>
    <br>
        <span>{{'common.vizseek_search_Invalid_text2'|cxTranslate}}
            <a href="https://n0c357rmy1njbuit2friqwu.blob.core.windows.net/documents/gIJArKnXI0EBhB_Y497499_EN_000.pdf"
                target="_blank">
                {{'common.Vizseek_Search_Guide'|cxTranslate}}
                <img src="/icons/pdf-grey.svg" alt="" class="PDF" width="20" /> </a>
            {{'common.vizseek_search_Invalid_text3'|cxTranslate}}
            <a class="contactUsLink"  (click)="contactRedirect()">
                {{'common.sold_to_popup_text_two'|cxTranslate}}
                <img src="/icons/mail-kb.svg" alt="" class="mail" width="20" /> </a>
        </span>


    </div>
</mat-dialog-content>